/* unplugin-vue-components disabled */import script from "./IntegralProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./IntegralProductDetails.vue?vue&type=style&index=0&id=36bcef34&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bcef34"]])

export default __exports__